/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Guide_Save_FailedInputs */

const en_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save guide: ${i?.error}`)
};

const fr_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’enregistrement du guide : ${i?.error}`)
};

const de_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leitfaden konnte nicht gespeichert werden: ${i?.error}`)
};

const it_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile salvare la guida: ${i?.error}`)
};

const ru_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось сохранить руководство: ${i?.error}`)
};

const es_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo guardar la guía: ${i?.error}`)
};

const zh_cn2_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`指南保存失败：${i?.error}`)
};

const ja_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ガイドの保存に失敗しました: ${i?.error}`)
};

const hi_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`गाइड को सहेजने में विफल: ${i?.error}`)
};

const pt_pt2_knp_guide_save_failed = /** @type {(inputs: Knp_Guide_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao salvar o guia: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to save guide: {error}" |
*
* @param {Knp_Guide_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_save_failed = /** @type {((inputs: Knp_Guide_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_save_failed(inputs)
	if (locale === "de") return de_knp_guide_save_failed(inputs)
	if (locale === "it") return it_knp_guide_save_failed(inputs)
	if (locale === "ru") return ru_knp_guide_save_failed(inputs)
	if (locale === "es") return es_knp_guide_save_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_save_failed(inputs)
	if (locale === "ja") return ja_knp_guide_save_failed(inputs)
	if (locale === "hi") return hi_knp_guide_save_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_save_failed(inputs)
	return en_knp_guide_save_failed(inputs)
});